var Qa = Object.defineProperty, Ya = Object.defineProperties;
var ja = Object.getOwnPropertyDescriptors;
var xt = Object.getOwnPropertySymbols;
var Ka = Object.prototype.hasOwnProperty, Ja = Object.prototype.propertyIsEnumerable;
var Et = (U, o, y) => o in U ? Qa(U, o, { enumerable: !0, configurable: !0, writable: !0, value: y }) : U[o] = y, K = (U, o) => {
  for (var y in o || (o = {}))
    Ka.call(o, y) && Et(U, y, o[y]);
  if (xt)
    for (var y of xt(o))
      Ja.call(o, y) && Et(U, y, o[y]);
  return U;
}, oe = (U, o) => Ya(U, ja(o));
var R = (U, o, y) => new Promise((P, z) => {
  var $ = (N) => {
    try {
      L(y.next(N));
    } catch (I) {
      z(I);
    }
  }, q = (N) => {
    try {
      L(y.throw(N));
    } catch (I) {
      z(I);
    }
  }, L = (N) => N.done ? P(N.value) : Promise.resolve(N.value).then($, q);
  L((y = y.apply(U, o)).next());
});
import { u as Oe, o as Qt, b as Yt, c as s, e as r, f as a, l as D, j as Ga, n as ye, r as at, a as g, m as F, q as de, B as st, y as Xa, t as u, F as C, p as Le, h as _, g as n, i as d, k as v, w, x as Ie, s as Za, v as f, ar as Me } from "./define-element-XpjsV6s1.js";
import { C as es } from "./Cart-DB72546L.js";
import { B as Y } from "./Button-D5lKR5Sd.js";
import { R as De, E as ts, C as as } from "./CheckoutPayment-DikiEx66.js";
import { I as ge } from "./Input-yplyeePD.js";
import { f as Lt, a as ss, T as is } from "./Tab-Bza7rjAG.js";
import { P as ls } from "./Phone-BBsTgKL1.js";
import { L as ns } from "./LoginForm-D68uOH8H.js";
import { A as rs } from "./Address-QnUa_uo4.js";
import { A as Xe } from "./Accordion-ETC-82Nb.js";
import { D as os } from "./DateOfBirth-C57dVBDY.js";
import { L as $e } from "./Loader-CeIJU_1y.js";
import { L as qe, u as us, C as It } from "./use-payment-CcwDaLQz.js";
import { i as Pe, b as xe, t as Ze } from "./utils-CMsllPx8.js";
import "./Select-CfkMpX3N.js";
import { _ as it } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as ds } from "./use-states-T4YLdFAy.js";
import { u as ps } from "./use-addresses-Wp77HwbF.js";
import { u as vs } from "./use-user-CwEHAZOt.js";
/* empty css                                                                      */
import { u as fs, a as ms, p as et, b as Dt, d as cs, e as gs } from "./StripePaymentForm-CDVtd19T.js";
import { R as Ot } from "./ReferralNote-SzjhZsM4.js";
import { P as ys } from "./Prop65Warning-CQH0AdaD.js";
import { c as hs } from "./data-D9rfxhB4.js";
import { u as _s, i as ue, s as ks } from "./use-cart-D8NOb7eE.js";
import { u as bs } from "./use-config-1FCHS5th.js";
import { u as ws, a as Ss } from "./query-client-DZ5Df1It.js";
import { f as jt } from "./format-currency-D_QngrXg.js";
import { L as Ee } from "./Link-Ck5HVnu-.js";
import { T as Tt } from "./Textarea-DR6xAbu0.js";
const tt = "stripe-express-checkout", Cs = {
  __name: "StripeExpressCheckout",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(U) {
    const o = U, y = Oe("container"), P = Oe(tt), {
      isStripeReady: z,
      availablePaymentMethods: $
    } = fs(y, tt, P);
    return Qt(() => {
      Yt(y.value, o.inheritStyle);
    }), (q, L) => (s(), r("div", {
      class: ye(["offset-stripe-express-checkout", { "has-available-payment-methods": a($) }]),
      ref: "container"
    }, [
      a(z) ? (s(), r("div", {
        key: 0,
        ref: tt
      })) : (s(), D(qe, {
        key: 1,
        label: "Loading express checkout…"
      })),
      Ga(q.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, Us = /* @__PURE__ */ it(Cs, [["__scopeId", "data-v-b2464831"]]);
function Ps() {
  return ws(), Ss({
    queryKey: ["countries"],
    queryFn: () => R(null, null, function* () {
      return yield at("cart/countries");
    })
  });
}
const xs = "https://map-api.viadelivery.pro/point-list";
function Es() {
  const U = g([]), o = g(null), y = g(!1), P = g(null), z = g(null), $ = F(
    () => {
      var I;
      return (I = U.value.find((W) => W.id === P.value)) != null ? I : null;
    }
  );
  function q(I, W, te, O, j, M) {
    return R(this, null, function* () {
      var X, Z;
      if (!(Pe(I) || Pe(W) || Pe(te) || Pe(O) || Pe(j))) {
        y.value = !0, z.value = null, U.value = [], o.value = null, P.value = null;
        try {
          const V = `${I}, ${W} ${te} ${O}`, J = new URLSearchParams({
            id: j,
            address: V
          });
          M != null && J.set("order_price", String(M));
          const ee = yield fetch(`${xs}?${J}`);
          if (!ee.ok) {
            z.value = "Failed to load pickup locations.";
            return;
          }
          const ae = yield ee.json();
          o.value = (X = ae.origin) != null ? X : null, U.value = (Z = ae.points) != null ? Z : [];
        } catch (V) {
          z.value = "Failed to load pickup locations.";
        } finally {
          y.value = !1;
        }
      }
    });
  }
  function L(I) {
    P.value = I;
  }
  function N() {
    U.value = [], o.value = null, P.value = null, z.value = null;
  }
  return {
    locations: U,
    origin: o,
    isLoading: y,
    selectedLocationId: P,
    selectedLocation: $,
    error: z,
    fetchPickupLocations: q,
    selectLocation: L,
    clearLocations: N
  };
}
const Ls = {
  key: 0,
  class: "offset-pickup-locations"
}, Is = {
  key: 1,
  class: "offset-pickup-locations-error",
  role: "alert"
}, Ds = { class: "offset-pickup-location-info" }, Os = { class: "offset-pickup-location-meta" }, Ts = {
  key: 3,
  class: "offset-checkout-info"
}, As = {
  class: "offset-pickup-map-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Pickup locations map"
}, zs = { class: "offset-pickup-map-header" }, Vs = ["src"], Fs = {
  __name: "PickupLocations",
  props: {
    address: { type: String, default: "" },
    city: { type: String, default: "" },
    state: { type: String, default: "" },
    zip: { type: String, default: "" },
    orderPrice: { type: Number, default: null },
    selectedLocationId: { type: String, default: null },
    viaDeliveryId: {
      type: String,
      default: () => {
        var U;
        return ((U = window.OFFSET) == null ? void 0 : U.viaDeliveryId) || void 0 || "";
      }
    }
  },
  emits: ["update:selectedLocationId", "select"],
  setup(U, { emit: o }) {
    const y = U, P = o, {
      locations: z,
      origin: $,
      isLoading: q,
      selectedLocationId: L,
      selectedLocation: N,
      error: I,
      fetchPickupLocations: W,
      selectLocation: te
    } = Es(), O = F(() => !!y.viaDeliveryId), j = F(
      () => !!(y.address && y.city && y.state && y.zip)
    ), M = g(!1), X = F(() => {
      if (!$.value) return null;
      const k = new URLSearchParams({
        dealerId: y.viaDeliveryId,
        lat: String($.value.lat),
        lng: String($.value.lng),
        zoom: "12",
        action: "true",
        lang: "en"
      });
      return y.orderPrice != null && k.set("orderCost", String(y.orderPrice)), L.value && k.set("pointId", L.value), `https://widget.viadelivery.pro/via.maps/?${k}`;
    });
    de(
      () => y.selectedLocationId,
      (k) => {
        L.value = k != null ? k : null;
      }
    ), de(
      () => [y.address, y.city, y.state, y.zip],
      ([k, b, S, m]) => {
        var G;
        k && b && S && m && O.value && W(
          k,
          b,
          S,
          m,
          y.viaDeliveryId,
          (G = y.orderPrice) != null ? G : void 0
        );
      },
      { immediate: !0 }
    );
    function Z(k) {
      te(k), P("update:selectedLocationId", k), P("select", N.value);
    }
    function V(k) {
      let b;
      try {
        b = JSON.parse(k.data);
      } catch (m) {
        return;
      }
      if (!b || b.emit !== "via-map") return;
      const S = b.id;
      S && z.value.find((m) => m.id === S) && (Z(S), M.value = !1);
    }
    const J = Oe("mapCloseButton");
    let ee = null;
    de(M, (k) => {
      k ? (window.addEventListener("message", V), ee = document.activeElement, st(() => {
        var b;
        return (b = J.value) == null ? void 0 : b.focus();
      })) : (window.removeEventListener("message", V), ee && typeof ee.focus == "function" && ee.focus());
    });
    function ae(k) {
      k.key === "Escape" && (M.value = !1);
    }
    Xa(() => {
      window.removeEventListener("message", V);
    });
    function he(k) {
      if (!k) return "";
      const [b, S] = k.split(":").map(Number), m = b >= 12 ? "PM" : "AM", G = b % 12 || 12;
      return S ? `${G}:${String(S).padStart(2, "0")} ${m}` : `${G} ${m}`;
    }
    function Te(k) {
      return `${(k / 1609.34).toFixed(1)} mi`;
    }
    function se(k) {
      var b, S;
      return ((b = k.price) != null ? b : 0) + ((S = k.fuel_surcharge) != null ? S : 0);
    }
    return (k, b) => O.value ? (s(), r("div", Ls, [
      a(q) ? (s(), D($e, { key: 0 })) : a(I) ? (s(), r("div", Is, u(a(I)), 1)) : a(z).length > 0 ? (s(!0), r(C, { key: 2 }, Le(a(z), (S) => (s(), r("label", {
        key: S.id,
        class: ye(["offset-pickup-location", { active: a(L) === S.id }])
      }, [
        _(De, {
          name: "pickupLocation",
          value: S.id,
          checked: a(L) === S.id,
          onChange: (m) => Z(S.id)
        }, null, 8, ["value", "checked", "onChange"]),
        n("div", Ds, [
          n("strong", null, u(S.description), 1),
          n("span", null, u(S.full_address), 1),
          n("span", Os, [
            d(u(he(S.working_time_from)) + " – " + u(he(S.working_time_to)) + " · " + u(Te(S.distance)) + " · " + u(S.min_days) + "–" + u(S.max_days) + " days ", 1),
            se(S) > 0 ? (s(), r(C, { key: 0 }, [
              d(" · " + u(a(jt)(se(S))), 1)
            ], 64)) : v("", !0)
          ])
        ])
      ], 2))), 128)) : j.value && !a(q) ? (s(), r("div", Ts, " No pickup locations found near this address. ")) : v("", !0),
      a($) ? (s(), D(Y, {
        key: 4,
        variant: "alt",
        class: "offset-pickup-map-btn",
        onClick: b[0] || (b[0] = (S) => M.value = !0)
      }, {
        default: w(() => b[3] || (b[3] = [
          d(" Map It ", -1)
        ])),
        _: 1,
        __: [3]
      })) : v("", !0),
      M.value ? (s(), r("div", {
        key: 5,
        class: "offset-pickup-map-overlay",
        onClick: b[2] || (b[2] = Ie((S) => M.value = !1, ["self"])),
        onKeydown: ae
      }, [
        n("div", As, [
          n("div", zs, [
            b[4] || (b[4] = n("strong", null, "Pickup Locations", -1)),
            n("button", {
              ref: "mapCloseButton",
              class: "offset-pickup-map-close",
              onClick: b[1] || (b[1] = (S) => M.value = !1),
              "aria-label": "Close map"
            }, " × ", 512)
          ]),
          X.value ? (s(), r("iframe", {
            key: 0,
            src: X.value,
            title: "Map of nearby pickup locations",
            frameborder: "0",
            width: "100%",
            height: "100%",
            class: "offset-pickup-map-iframe"
          }, null, 8, Vs)) : v("", !0)
        ])
      ], 32)) : v("", !0)
    ])) : v("", !0);
  }
}, Ns = /* @__PURE__ */ it(Fs, [["__scopeId", "data-v-804d8cb6"]]), Ms = ["textContent"], $s = {
  key: 0,
  class: "offset-checkout-main",
  role: "status",
  "aria-live": "polite"
}, qs = { class: "section" }, Rs = {
  key: 1,
  class: "offset-checkout-main",
  role: "status",
  "aria-live": "polite"
}, Bs = { class: "section" }, Ws = {
  key: 2,
  class: "offset-checkout-main",
  role: "alert"
}, Hs = { class: "section" }, Qs = {
  key: 3,
  class: "offset-checkout-main"
}, Ys = { class: "section" }, js = ["innerHTML"], Ks = { key: 1 }, Js = {
  key: 0,
  class: "section"
}, Gs = {
  key: 0,
  class: "error"
}, Xs = { key: 1 }, Zs = {
  key: 4,
  class: "offset-checkout-main"
}, ei = {
  key: 0,
  class: "section offset-checkout-invoice-review"
}, ti = { class: "offset-checkout-contact-info" }, ai = ["href"], si = { key: 0 }, ii = { key: 1 }, li = { class: "section offset-checkout-contact" }, ni = {
  key: 0,
  class: "offset-checkout-email"
}, ri = { class: "grouped" }, oi = {
  key: 0,
  class: "error"
}, ui = {
  key: 1,
  class: "error"
}, di = { class: "grouped" }, pi = { class: "grouped" }, vi = ["textContent"], fi = { class: "offset-checkout-info offset-checkout-shipping-info" }, mi = { class: "grouped" }, ci = { class: "grouped offset-checkout-shipping-address-actions" }, gi = { class: "offset-checkout-address use-different" }, yi = ["innerHTML"], hi = { key: 0 }, _i = {
  key: 1,
  class: "error",
  role: "alert"
}, ki = {
  key: 2,
  class: "offset-checkout-info"
}, bi = ["innerHTML"], wi = {
  key: 0,
  class: "offset-checkout-shipping-insurance"
}, Si = ["textContent"], Ci = ["innerHTML"], Ui = { key: 0 }, Pi = { key: 0 }, xi = { key: 1 }, Ei = { class: "offset-checkout-notes" }, Li = { class: "char-counter" }, Ii = { class: "char-counter" }, Di = {
  key: 0,
  class: "offset-checkout-cart-header"
}, Oi = { key: 1 }, Ti = { key: 0 }, Ai = { class: "offset-order-summary-actions" }, zi = {
  key: 0,
  class: "error",
  role: "alert"
}, Vi = {
  key: 3,
  class: "offset-checkout-info"
}, Fi = ["href"], Ni = ["href"], Mi = {
  key: 0,
  class: "offset-checkout-powered-by"
}, $i = ["href"];
var At, zt, Vt, Ft, Nt, Mt, $t, qt, Rt, Bt, Wt, Ht;
const qi = {
  __name: "Checkout",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    cartUrl: {
      type: String,
      default: (zt = (At = window.OFFSET) == null ? void 0 : At.cartUrl) != null ? zt : "/cart"
    },
    checkoutUrl: {
      type: String,
      default: (Ft = (Vt = window.OFFSET) == null ? void 0 : Vt.checkoutUrl) != null ? Ft : "/checkout"
    },
    shopUrl: {
      type: String,
      default: (Mt = (Nt = window.OFFSET) == null ? void 0 : Nt.shopUrl) != null ? Mt : "/"
    },
    offeringUrl: {
      type: String,
      default: (qt = ($t = window.OFFSET) == null ? void 0 : $t.offeringUrl) != null ? qt : "/offering"
    },
    isOffering: {
      type: Boolean,
      default: !1
    },
    // Event ticket checkout — no shipping address, method, or ship date;
    // sets the cart's shipping_exempt config so shipping isn't required or
    // charged. See EventCheckout.vue, which forces this true.
    shippingExempt: {
      type: Boolean,
      default: !1
    },
    termsUrl: {
      type: String,
      default: (Bt = (Rt = window.OFFSET) == null ? void 0 : Rt.termsUrl) != null ? Bt : "/terms"
    },
    privacyUrl: {
      type: String,
      default: (Ht = (Wt = window.OFFSET) == null ? void 0 : Wt.privacyUrl) != null ? Ht : "/privacy"
    },
    disableExpressCheckout: {
      type: Boolean,
      default: !1
    },
    referralQuestionPlacement: {
      type: String,
      default: "receipt"
      // "receipt" | "signup"
    },
    // Per-client override for ReferralNote's options list (e.g. a one-off
    // list for a single account) — passed straight through to ReferralNote,
    // which falls back to its own generic default when this isn't set. A
    // custom-element attribute arrives as a raw JSON string (see
    // ReferralNote.vue's own options prop for why); ReferralNote parses it.
    referralOptions: {
      type: [Array, String],
      default: void 0
    }
  },
  setup(U) {
    const o = U;
    Za(o.shippingExempt ? "event" : o.isOffering ? "offering" : "cart");
    const y = crypto.randomUUID().replace(/-/g, "").slice(0, 12), P = g(!1), z = g(!1), $ = g(null), q = g(!0), L = g(!1), N = g(!1), I = g(!1), W = g(null), te = g(null), O = g(""), j = g(y), M = g(y), X = g(!1), Z = g(!1), V = g(""), J = g(""), ee = g(!1), ae = g(!1), he = g(!1), Te = g(!1), se = g(!1), k = g(!1), b = g(!1), m = g({
      email: !1,
      password: !1,
      confirmPassword: !1,
      referralSource: !1,
      shippingData: {
        first_name: !1,
        last_name: !1,
        phone: !1,
        birthday: !1,
        address: !1,
        city: !1,
        state: !1,
        zip: !1
      },
      billingData: {
        first_name: !1,
        last_name: !1,
        address: !1,
        city: !1,
        state: !1,
        zip: !1
      }
    });
    function G() {
      return {
        title: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        birthday: "",
        country: "US",
        businessName: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        default: !1
      };
    }
    const l = g(G());
    function Kt(i) {
      var e;
      return oe(K({}, G()), {
        first_name: i.shipping_first_name || "",
        last_name: i.shipping_last_name || "",
        address: i.shipping_address || "",
        address2: i.shipping_address_2 || "",
        city: i.shipping_city || "",
        state: i.shipping_state || "",
        zip: i.shipping_zip || "",
        country: i.shipping_country || "US",
        businessName: i.shipping_company || "",
        email: ((e = A.value) == null ? void 0 : e.email) || ""
      });
    }
    const ie = g(""), le = g(""), ke = g(!1);
    function Jt() {
      return Math.random().toString(36).substring(2, 11) + Math.random().toString(36).substring(2, 11);
    }
    const T = g({
      first_name: "",
      last_name: "",
      country: "US",
      address: "",
      address_2: "",
      city: "",
      state: "",
      zip: "",
      businessName: ""
    }), {
      isPending: Gt,
      data: A,
      loginMutation: Xt,
      isValidUser: H,
      userExists: Zt,
      subscribeMutation: ea,
      prefilledData: lt,
      updateProfile: ta
    } = vs(), nt = new URLSearchParams(window.location.search).get("orderid");
    de(
      [Gt, H],
      (t) => R(null, [t], function* ([i, e]) {
        if (!(f(nt) || i || !e)) {
          z.value = !0;
          try {
            let c = yield at("customer/orders");
            Array.isArray(c) || (c = c && !c.error ? Object.values(c) : []);
            const h = c.find(
              (ve) => String(ve.id) === String(nt)
            );
            if (!h)
              return;
            W.value = h.id, l.value = Kt(h), $.value = h, P.value = !0;
          } finally {
            z.value = !1;
          }
        }
      }),
      { immediate: !0 }
    );
    const rt = F(() => {
      if (!$.value)
        return null;
      const i = $.value;
      return {
        items: Array.isArray(i.products) ? i.products : [],
        subtotal: parseFloat(i.subtotal) || 0,
        discount: parseFloat(i.discount) || 0,
        shipping: parseFloat(i.shipping) || 0,
        tax: parseFloat(i.tax) || 0,
        total: parseFloat(i.total) || 0,
        item_count: parseInt(i.item_count, 10) || 0,
        ca_redemption_value: parseFloat(i.ca_redemption_value) || 0,
        me_bottle_deposit: parseFloat(i.me_bottle_deposit) || 0,
        shipping_method_name: i.shipping_method_name || ""
      };
    }), {
      mutate: Ri,
      isPending: Bi,
      isError: Wi,
      error: Hi
    } = Xt, {
      mutate: aa,
      isPending: Re,
      isError: sa,
      error: ia
    } = ea, { config: x } = bs(), {
      cart: E,
      loadCart: ot,
      fetchShippingOptions: la,
      shippingOptions: Be,
      isShippingOptionsLoading: na,
      shippingOptionsError: ra,
      isSelectingShippingAddressForCart: oa,
      requestedShipDates: Ae,
      updateCartConfig: be,
      selectShippingAddressForCart: ua,
      selectShippingMethodForCart: da,
      selectPaymentForCart: pa,
      selectedShippingMethod: Q,
      selectedRequestedShipDate: pe,
      checkout: We,
      isCheckingOut: ut,
      isUpdatingCart: va,
      clearCart: fa
    } = _s(), { data: ma } = ds(), { data: dt } = Ps(), {
      data: ne,
      hasAddresses: ca,
      selectedAddress: p,
      createAddressMutation: ga,
      updateAddressMutation: ya,
      deleteAddressMutation: pt,
      isAnyAddressPending: vt
    } = ps(), { mutate: ha } = ga, { mutate: _a } = ya, { mutate: Qi } = pt, {
      selectedPayment: re
    } = us(), ze = g(!1), Ve = g(!1), B = g(!1), He = g(null), me = g(null), ft = F(() => me.value ? null : Q.value);
    function ka(i) {
      He.value = null, me.value = null, da(i);
    }
    function ba(i) {
      me.value = i;
    }
    const {
      wantsToComplete: wa,
      newPaymentId: Sa,
      shouldCheckout: mt,
      paymentIntentId: Qe,
      error: ct
    } = ms(), we = Oe("container"), Se = Oe("dob"), Fe = g(!1), Ca = F(() => x.value.enable_age_restriction ? parseInt(x.value.restriction_age) || 21 : 0), Ua = F(() => ut.value || Ue.value ? "Processing..." : et(te.value) || "Pay now"), ce = g(""), Pa = F(() => `https://offsetcommerce.com?ref=${encodeURIComponent(window.location.hostname)}`), xa = F(() => {
      var i;
      return ue.value ? "Pending Order Review" : P.value ? `Thank you, ${((i = A.value) == null ? void 0 : i.first_name) || l.value.first_name}.` : "Checkout";
    }), Ce = F(() => P.value && rt.value ? !1 : E.value.items.length === 0), Ye = F(() => ue.value && f(E.value.config.allowed_methods)), gt = F(() => {
      if (!ue.value || f(E.value.config.allowed_methods))
        return null;
      try {
        return JSON.parse(E.value.config.allowed_methods);
      } catch (i) {
        return null;
      }
    }), Ea = F(() => dt.value ? ["US", ...dt.value].map((i) => hs[i]) : []), La = F(() => {
      const i = {};
      if (!Be.value)
        return i;
      let e = Be.value;
      gt.value && (e = e.filter(
        (c) => gt.value.includes(String(c.id))
      )), e.forEach((c) => {
        let h = (c.type || "shipping").toLowerCase();
        h === "shipping" ? h = "Shipping Options" : h === "pickup" ? h = "Will Call Options" : h === "3rdparty" && (h = "Transfer Options"), i[h] || (i[h] = []), i[h].push(c);
      });
      const t = [];
      return i["Shipping Options"] && t.push({
        type: "Shipping Options",
        options: i["Shipping Options"]
      }), i["Transfer Options"] && t.push({
        type: "Transfer Options",
        options: i["Transfer Options"]
      }), i["Will Call Options"] && t.push({
        type: "Will Call Options",
        options: i["Will Call Options"]
      }), t;
    }), je = F(() => {
      const i = et(te.value) !== null;
      return !(Ce.value || !H.value || !o.shippingExempt && !p.value || !o.shippingExempt && !Q.value && !me.value || !i && (!re.value || Ve.value || ze.value) || !o.shippingExempt && Ae.value.length > 0 && !pe.value && !B.value);
    });
    function yt(i) {
      window.location = i;
    }
    function Ia() {
      Fe.value = !Fe.value;
    }
    function ht() {
      return R(this, null, function* () {
        if (f(O.value) || H.value)
          return;
        if (!xe(O.value)) {
          m.value.email = !0;
          return;
        }
        I.value = !0;
        const i = yield Zt(O.value);
        i ? (q.value = !1, L.value = !0) : (q.value = !0, N.value = !0, L.value = !1), I.value = !1, st(() => {
          var e, t, c, h;
          i ? (t = (e = we.value) == null ? void 0 : e.querySelector("input[type='password']")) == null || t.focus() : (h = (c = we.value) == null ? void 0 : c.querySelector("input[autocomplete='given-name']")) == null || h.focus();
        });
      });
    }
    function Da() {
      q.value = !1, L.value = !0;
    }
    function Oa() {
      q.value = !0, N.value = !0, L.value = !1;
    }
    let Ke = !1;
    function Je() {
      !Ke && (f(j.value) || f(M.value)) || (Ke = !0, j.value !== M.value ? X.value = !0 : X.value = !1, j.value.length < 8 ? Z.value = !0 : Z.value = !1);
    }
    const Ta = F(() => {
      var i, e;
      return ke.value && xe(O.value) && !f(l.value.first_name) && !f(l.value.last_name) && !f(l.value.phone) && !!((i = Se.value) != null && i.isComplete) && !((e = Se.value) != null && e.isUnderAge) && (o.referralQuestionPlacement !== "signup" || !f(V.value));
    });
    function Aa() {
      return R(this, null, function* () {
        var t, c;
        if (H.value || Re.value || !ke.value)
          return;
        xe(O.value) || (m.value.email = !0), Ke = !0, Je(), Ma();
        const i = o.referralQuestionPlacement === "signup";
        if (!xe(O.value) || f(j.value) || f(M.value) || X.value || Z.value || f(l.value.first_name) || f(l.value.last_name) || f(l.value.phone) || !((t = Se.value) != null && t.isComplete) || (c = Se.value) != null && c.isUnderAge || i && f(V.value))
          return;
        const e = /* @__PURE__ */ new Date();
        yield aa(oe(K({
          first_name: l.value.first_name,
          last_name: l.value.last_name,
          email: O.value,
          phone: l.value.phone,
          mobile_phone: l.value.phone,
          password: j.value,
          birthday: l.value.birthday
        }, i ? {
          referral_source: V.value || void 0,
          referral_note: J.value || void 0
        } : {}), {
          customer_type: x.value.default_customer_type || "Mailing List",
          customer_source: "Open Cart",
          page_source: "Cart",
          group_id: x.value.cart_signup_group || x.value.default_group || "",
          agreed_to_terms_privacy: ke.value ? "Yes" : "No",
          agreed_to_mailing_list: "Yes",
          marketing_opt_in: "Yes",
          consent_date: e.toISOString().split("T")[0],
          consent_time: e.toTimeString().split(" ")[0],
          consent_token: Jt()
        })), i && (Te.value = !0), Ze("CompleteRegistration"), yield ot();
      });
    }
    function za() {
      k.value = !0, se.value = !1, l.value = G();
    }
    function Va(i) {
      k.value = !1, se.value = !0;
      const e = ne.value.find((t) => t.id === i);
      l.value = K(K({}, l.value), e);
    }
    function Fa(i) {
      return R(this, null, function* () {
        yield pt.mutate(i), l.value = G();
      });
    }
    function Na() {
      k.value = !1, se.value = !1, l.value = G();
    }
    function Ma() {
      var i;
      m.value.shippingData.first_name = f(l.value.first_name), m.value.shippingData.last_name = f(l.value.last_name), m.value.shippingData.phone = f(l.value.phone), m.value.shippingData.birthday = !((i = Se.value) != null && i.isComplete), m.value.referralSource = o.referralQuestionPlacement === "signup" && f(V.value);
    }
    function $a() {
      m.value.shippingData.first_name = !1, m.value.shippingData.last_name = !1, m.value.shippingData.phone = !1, m.value.shippingData.address = !1, m.value.shippingData.address2 = !1, m.value.shippingData.city = !1, m.value.shippingData.state = !1, m.value.shippingData.zip = !1, m.value.shippingData.country = !1, m.value.shippingData.businessName = !1, m.value.shippingData.birthday = !1, m.value.shippingData.email = !1, f(l.value.first_name) && (m.value.shippingData.first_name = !0), f(l.value.last_name) && (m.value.shippingData.last_name = !0), f(l.value.phone) && (m.value.shippingData.phone = !0), f(l.value.address) && (m.value.shippingData.address = !0), f(l.value.city) && (m.value.shippingData.city = !0), f(l.value.state) && (m.value.shippingData.state = !0), f(l.value.zip) && (m.value.shippingData.zip = !0);
    }
    function qa() {
      return R(this, null, function* () {
        if ($a(), !(f(l.value.first_name) || f(l.value.last_name) || //isEmpty(shippingData.value.phone) ||
        f(l.value.address) || f(l.value.city) || f(l.value.state) || f(l.value.zip))) {
          b.value = !0;
          try {
            se.value ? yield _a(K({}, l.value)) : yield ha(oe(K({}, l.value), {
              default: "1"
            })), k.value = !1, se.value = !1;
          } finally {
            b.value = !1;
          }
        }
      });
    }
    function Ra() {
      return R(this, null, function* () {
        if (!f(V.value)) {
          he.value = !1, ae.value = !0;
          try {
            yield ta({
              referral_source: V.value,
              referral_note: J.value
            }), ee.value = !0;
          } catch (i) {
            he.value = !0;
          }
          ae.value = !1;
        }
      });
    }
    function Ba(i) {
      const e = new URLSearchParams(window.location.search);
      e.set("orderid", i);
      const t = window.location.pathname + `?${e.toString()}` + window.location.hash;
      window.history.replaceState(null, "", t);
    }
    function Ne() {
      var i;
      l.value = oe(K({}, p.value), {
        email: A.value.email
      }), $.value = {
        products: E.value.items,
        subtotal: E.value.subtotal,
        discount: E.value.discount,
        shipping: E.value.shipping,
        tax: E.value.tax,
        total: E.value.total,
        item_count: E.value.item_count,
        ca_redemption_value: E.value.ca_redemption_value,
        me_bottle_deposit: E.value.me_bottle_deposit,
        shipping_method_name: ((i = Q.value) == null ? void 0 : i.name) || ""
      }, P.value = !0, Ba(W.value), st(() => {
        var e;
        (e = we.value) == null || e.scrollIntoView({ behavior: "smooth", block: "start" });
      }), Ze("Purchase", {
        currency: "USD",
        value: E.value.total,
        items: E.value.items.map((e) => ({
          id: e.sku,
          name: e.name,
          price: e.price,
          quantity: e.quantity
        })),
        subtotal: E.value.subtotal,
        discount: E.value.discount,
        tax: E.value.tax
      }), fa();
    }
    const Ue = g(!1);
    function Wa() {
      return R(this, null, function* () {
        if (!(!je.value || Ue.value)) {
          Ue.value = !0;
          try {
            yield Ha();
          } finally {
            Ue.value = !1;
          }
        }
      });
    }
    function Ha() {
      return R(this, null, function* () {
        ce.value = "";
        const i = et(te.value) != null, e = i && !Ve.value && !ze.value, t = o.shippingExempt ? T.value : p.value;
        if (e) {
          let c = null;
          try {
            const h = yield cs(x.value, E.value);
            c = h.paymentIntentId, W.value = yield We(oe(K({
              order_type: ue.value ? "Invoice" : "Web",
              sales_agent: "Customer"
            }, o.shippingExempt ? { shipping_exempt: 1 } : {
              // "" (not null/undefined) — the upstream cart API treats a
              // missing/null field as "leave unchanged" rather than "clear
              // it", so an actual empty string is required to genuinely
              // clear this field when the customer picks "arrange a
              // different date" instead of a specific one.
              requested_ship_date: B.value ? "" : pe.value,
              additional_order_notes: B.value ? "Customer requested to arrange a different ship date." : void 0,
              shipping_method: Q.value.id,
              shipping_title: Q.value.title,
              shipping_first_name: p.value.first_name,
              shipping_last_name: p.value.last_name,
              shipping_address: p.value.address,
              shipping_address_2: p.value.address_2,
              shipping_city: p.value.city,
              shipping_state: p.value.state,
              shipping_zip: p.value.zip,
              shipping_company: p.value.businessName,
              shipping_phone: p.value.phone,
              shipping_email: p.value.email || A.value.email
            }), {
              address: t.address,
              address_2: t.address_2,
              city: t.city,
              state: t.state,
              zip: t.zip,
              company: t.businessName,
              instructions: ie.value,
              gift_message: le.value,
              credit_id: h.creditId,
              stripe_payment_intent: c
            })), Ne();
          } catch (h) {
            c && Dt(c), h.message !== "cancelled" && (console.error(h, h.message), Me(h, { component: "Checkout.vue:finishCheckout" }), ce.value = h.message || "There was a problem processing your payment. Please try again.");
          }
        } else if (i)
          try {
            yield gs(
              {
                first_name: t.first_name,
                last_name: t.last_name,
                address: t.address,
                address_2: t.address_2,
                city: t.city,
                state: t.state,
                zip: t.zip,
                country: t.country,
                businessName: t.businessName,
                email: t.email || A.value.email,
                phone: t.phone
              },
              x.value,
              E.value
            ), Ne();
          } catch (c) {
            console.error(c, c.message), Me(c, { component: "Checkout.vue:finishCheckout" }), ce.value = c.message || "There was a problem processing your payment. Please try again.";
          }
        else
          try {
            W.value = yield We(oe(K({
              order_type: ue.value ? "Invoice" : "Web",
              sales_agent: "Customer"
            }, o.shippingExempt ? { shipping_exempt: 1 } : {
              // "" (not null/undefined) — the upstream cart API treats a
              // missing/null field as "leave unchanged" rather than "clear
              // it", so an actual empty string is required to genuinely
              // clear this field when the customer picks "arrange a
              // different date" instead of a specific one.
              requested_ship_date: B.value ? "" : pe.value,
              additional_order_notes: B.value ? "Customer requested to arrange a different ship date." : void 0,
              shipping_method: Q.value.id,
              shipping_title: Q.value.title,
              shipping_first_name: p.value.first_name,
              shipping_last_name: p.value.last_name,
              shipping_address: p.value.address,
              shipping_address_2: p.value.address_2,
              shipping_city: p.value.city,
              shipping_state: p.value.state,
              shipping_zip: p.value.zip,
              shipping_company: p.value.businessName,
              shipping_phone: p.value.phone,
              shipping_email: p.value.email || A.value.email
            }), {
              address: re.value.address,
              address_2: re.value.address_2,
              city: re.value.city,
              state: re.value.state,
              zip: re.value.zip,
              company: re.value.businessName,
              instructions: ie.value,
              gift_message: le.value,
              credit_id: re.value.id
            })), Ne();
          } catch (c) {
            console.error(c), Me(c, { component: "Checkout.vue:finishCheckout" }), ce.value = c.message || "There was a problem processing your order. Please try again.";
          }
      });
    }
    return de(Sa, (i) => R(null, null, function* () {
      i && (yield pa(i));
    })), de([mt, re], (t) => R(null, [t], function* ([i, e]) {
      var c, h, ve, fe, _e, _t, kt, bt, wt, St, Ct, Ut, Pt;
      if (!(!i || !e)) {
        mt.value = !1, l.value = oe(K({}, p.value), {
          email: A.value.email
        });
        try {
          W.value = yield We(oe(K({
            order_type: ue.value ? "Invoice" : "Web",
            sales_agent: "Customer"
          }, o.shippingExempt ? { shipping_exempt: 1 } : {
            // "" (not null/undefined) — see the other requested_ship_date
            // call sites in this file for why.
            requested_ship_date: B.value ? "" : pe.value,
            additional_order_notes: B.value ? "Customer requested to arrange a different ship date." : void 0,
            shipping_method: (c = Q.value) == null ? void 0 : c.id,
            shipping_title: (h = Q.value) == null ? void 0 : h.title,
            shipping_first_name: (ve = p.value) == null ? void 0 : ve.first_name,
            shipping_last_name: (fe = p.value) == null ? void 0 : fe.last_name,
            shipping_address: (_e = p.value) == null ? void 0 : _e.address,
            shipping_address_2: (_t = p.value) == null ? void 0 : _t.address_2,
            shipping_city: (kt = p.value) == null ? void 0 : kt.city,
            shipping_state: (bt = p.value) == null ? void 0 : bt.state,
            shipping_zip: (wt = p.value) == null ? void 0 : wt.zip,
            shipping_company: (St = p.value) == null ? void 0 : St.businessName,
            shipping_phone: (Ct = p.value) == null ? void 0 : Ct.phone,
            shipping_email: ((Ut = p.value) == null ? void 0 : Ut.email) || ((Pt = A.value) == null ? void 0 : Pt.email)
          }), {
            address: e.address,
            address_2: e.address_2,
            city: e.city,
            state: e.state,
            zip: e.zip,
            company: e.businessName,
            instructions: ie.value,
            gift_message: le.value,
            credit_id: e.id,
            stripe_payment_intent: Qe.value || void 0
          })), Ne();
        } catch (Ge) {
          console.error(Ge), Me(Ge, { component: "Checkout.vue:stripeShouldCheckout" }), ce.value = Ge.message || "There was a problem processing your order. Please try again.", Qe.value && Dt(Qe.value);
        }
      }
    })), de(
      [H, p, ne],
      () => R(null, null, function* () {
        o.shippingExempt || !H.value || !ne.value || ne.value.length === 0 || (yield la());
      }),
      { immediate: !0 }
    ), de(Ae, (i) => {
      !o.shippingExempt && i.length > 0 && !pe.value && !B.value && be({ requested_ship_date: i[0] });
    }), de(
      A,
      () => {
        A.value && (f(l.value.first_name) && (l.value.first_name = A.value.first_name || ""), f(l.value.last_name) && (l.value.last_name = A.value.last_name || ""));
      },
      { immediate: !0 }
    ), Qt(() => R(null, null, function* () {
      Yt(we.value, o.inheritStyle), o.shippingExempt && be({ shipping_exempt: 1 });
      const i = new URLSearchParams(window.location.search), e = i.get("preauth"), t = i.get("invoice");
      if (e && t && (yield at("cart/auth", {
        method: "POST",
        body: JSON.stringify({ authtoken: e })
      }), ks(t), yield ot()), new ResizeObserver((h) => {
        var fe, _e;
        (((_e = (fe = h[0]) == null ? void 0 : fe.contentRect) == null ? void 0 : _e.width) || 0) >= 768 && (Fe.value = !1);
      }).observe(we.value), f(O.value) && (O.value = lt.value.email), f(l.value.birthday)) {
        const h = lt.value.birthday;
        f(h) || (l.value.birthday = h);
      }
      Ze("InitiateCheckout", {
        currency: "USD",
        value: E.value.total,
        items: E.value.items.map((h) => ({
          id: h.sku,
          name: h.name,
          price: h.price,
          quantity: h.quantity
        }))
      });
    })), (i, e) => (s(), r("div", {
      class: ye([
        "offset-checkout",
        Ce.value ? "is-empty" : "",
        P.value ? "is-receipt" : ""
      ]),
      ref: "container"
    }, [
      n("h1", {
        class: "offset-checkout-title",
        textContent: u(xa.value)
      }, null, 8, Ms),
      z.value ? (s(), r("div", $s, [
        n("div", qs, [
          e[41] || (e[41] = n("h3", null, "Loading your receipt...", -1)),
          _($e)
        ])
      ])) : v("", !0),
      a(wa) ? (s(), r("div", Rs, [
        n("div", Bs, [
          e[42] || (e[42] = n("h3", null, "Completing your payment...", -1)),
          e[43] || (e[43] = n("p", null, " Please wait while we complete your payment. Do not refresh or close this page. ", -1)),
          _($e)
        ])
      ])) : v("", !0),
      a(ct) ? (s(), r("div", Ws, [
        n("div", Hs, [
          e[45] || (e[45] = n("h3", null, "There was an error processing your payment.", -1)),
          n("p", null, u(a(ct)), 1),
          _(Y, {
            onClick: e[0] || (e[0] = (t) => yt(U.checkoutUrl))
          }, {
            default: w(() => e[44] || (e[44] = [
              d("Try Again", -1)
            ])),
            _: 1,
            __: [44]
          })
        ])
      ])) : P.value ? (s(), r("div", Qs, [
        n("div", Ys, [
          n("em", null, "Order #" + u(W.value), 1),
          a(f)(a(x).message_order_confirmation_cart) ? (s(), r("p", Ks, " Your order has been confirmed and your payment method has been charged. You will also receive an order confirmation by email. Please review it and let us know if you have any questions. Once your order is ready for shipment, your Account order page will be updated and you will receive an email with tracking information. ")) : (s(), r("p", {
            key: 0,
            innerHTML: a(x).message_order_confirmation_cart
          }, null, 8, js)),
          o.shippingExempt ? v("", !0) : (s(), r(C, { key: 2 }, [
            e[55] || (e[55] = n("strong", null, "Shipping Information", -1)),
            d(" " + u(l.value.first_name) + " " + u(l.value.last_name), 1),
            e[56] || (e[56] = n("br", null, null, -1)),
            a(f)(l.value.businessName) ? v("", !0) : (s(), r(C, { key: 0 }, [
              d(u(l.value.businessName), 1),
              e[46] || (e[46] = n("br", null, null, -1))
            ], 64)),
            d(" " + u(l.value.address), 1),
            e[57] || (e[57] = n("br", null, null, -1)),
            a(f)(l.value.address2) ? v("", !0) : (s(), r(C, { key: 1 }, [
              d(u(l.value.address2), 1),
              e[47] || (e[47] = n("br", null, null, -1))
            ], 64)),
            d(" " + u(l.value.city) + ", " + u(l.value.state) + " " + u(l.value.zip), 1),
            e[58] || (e[58] = n("br", null, null, -1)),
            d(" " + u(l.value.country), 1),
            e[59] || (e[59] = n("br", null, null, -1)),
            B.value ? (s(), r(C, { key: 2 }, [
              e[48] || (e[48] = n("br", null, null, -1)),
              e[49] || (e[49] = d(" Requested Ship Date: ", -1)),
              e[50] || (e[50] = n("strong", null, "Please arrange a different date", -1)),
              e[51] || (e[51] = n("br", null, null, -1))
            ], 64)) : a(f)(a(pe)) ? v("", !0) : (s(), r(C, { key: 3 }, [
              e[52] || (e[52] = n("br", null, null, -1)),
              e[53] || (e[53] = d(" Your Requested Ship Date: ", -1)),
              n("strong", null, u(a(Lt)(a(pe))), 1),
              e[54] || (e[54] = n("br", null, null, -1))
            ], 64))
          ], 64))
        ]),
        a(A) && a(f)(a(A).referral_source) && !Te.value ? (s(), r("div", Js, [
          ee.value ? (s(), r("p", Xs, "Thank you for letting us know.")) : (s(), r(C, { key: 0 }, [
            he.value ? (s(), r("div", Gs, e[60] || (e[60] = [
              n("p", null, "There was an error sending your referral. Please try again.", -1)
            ]))) : v("", !0),
            _(Ot, {
              source: V.value,
              "onUpdate:source": e[1] || (e[1] = (t) => V.value = t),
              note: J.value,
              "onUpdate:note": e[2] || (e[2] = (t) => J.value = t),
              options: o.referralOptions
            }, null, 8, ["source", "note", "options"]),
            _(Y, {
              onClick: Ra,
              disabled: ae.value,
              textContent: u(ae.value ? "Sending..." : "Send")
            }, null, 8, ["disabled", "textContent"])
          ], 64))
        ])) : v("", !0)
      ])) : Ce.value ? v("", !0) : (s(), r("div", Zs, [
        a(ue) ? (s(), r("div", ei, [
          n("p", null, [
            a(A) ? (s(), r(C, { key: 0 }, [
              d(u(a(A).first_name) + ", ", 1)
            ], 64)) : v("", !0),
            e[61] || (e[61] = d("please review the order we've put together for you and make sure your Delivery and Billing details are accurate. If you would like to make any further adjustments, please contact us. ", -1))
          ]),
          n("div", ti, [
            e[64] || (e[64] = n("h3", null, "We're here to help", -1)),
            n("div", null, [
              n("a", {
                href: `mailto:${a(x).company_email}`
              }, u(a(x).company_email), 9, ai)
            ]),
            a(x).company_phone ? (s(), r("div", si, [
              d(u(a(x).company_phone) + " ", 1),
              e[62] || (e[62] = n("span", null, "(Phone)", -1))
            ])) : v("", !0),
            a(x).company_text ? (s(), r("div", ii, [
              d(u(a(x).company_text) + " ", 1),
              e[63] || (e[63] = n("span", null, "(Text)", -1))
            ])) : v("", !0)
          ])
        ])) : v("", !0),
        i.$props.disableExpressCheckout ? v("", !0) : (s(), D(Us, { key: 1 }, {
          default: w(() => e[65] || (e[65] = [
            n("div", { style: { "text-align": "center" } }, "OR", -1)
          ])),
          _: 1,
          __: [65]
        })),
        n("div", li, [
          a(H) ? (s(), r(C, { key: 0 }, [
            n("h3", null, [
              n("strong", null, u(a(A).first_name) + " " + u(a(A).last_name), 1)
            ]),
            n("div", null, u(a(A).email), 1)
          ], 64)) : (s(), r(C, { key: 1 }, [
            n("h3", null, [
              e[68] || (e[68] = d(" Contact ", -1)),
              L.value ? (s(), D(Ee, {
                key: 1,
                onClick: Ie(Oa, ["prevent"])
              }, {
                default: w(() => e[67] || (e[67] = [
                  d("Sign Up", -1)
                ])),
                _: 1,
                __: [67]
              })) : (s(), D(Ee, {
                key: 0,
                onClick: Ie(Da, ["prevent"])
              }, {
                default: w(() => e[66] || (e[66] = [
                  d("Login", -1)
                ])),
                _: 1,
                __: [66]
              }))
            ]),
            q.value ? (s(), r("div", ni, [
              _(ge, {
                type: "email",
                modelValue: O.value,
                "onUpdate:modelValue": e[3] || (e[3] = (t) => O.value = t),
                onChange: ht,
                label: "Email",
                required: "",
                floating: !0,
                disabled: I.value,
                invalid: m.value.email
              }, null, 8, ["modelValue", "disabled", "invalid"]),
              !L.value && !N.value ? (s(), D(Y, {
                key: 0,
                variant: "alt",
                onClick: ht,
                disabled: !a(xe)(O.value) || I.value
              }, {
                default: w(() => e[69] || (e[69] = [
                  d(" Continue ", -1)
                ])),
                _: 1,
                __: [69]
              }, 8, ["disabled"])) : v("", !0)
            ])) : v("", !0),
            I.value ? (s(), D(qe, {
              key: 1,
              label: "Password"
            })) : v("", !0),
            q.value && N.value ? (s(), r(C, { key: 2 }, [
              a(f)(a(y)) ? (s(), r(C, { key: 0 }, [
                n("div", ri, [
                  _(ge, {
                    type: "password",
                    modelValue: j.value,
                    "onUpdate:modelValue": e[4] || (e[4] = (t) => j.value = t),
                    label: "Password",
                    required: "",
                    floating: !0,
                    onChange: Je
                  }, null, 8, ["modelValue"]),
                  _(ge, {
                    type: "password",
                    modelValue: M.value,
                    "onUpdate:modelValue": e[5] || (e[5] = (t) => M.value = t),
                    label: "Confirm Password",
                    required: "",
                    floating: !0,
                    onChange: Je
                  }, null, 8, ["modelValue"])
                ]),
                X.value ? (s(), r("em", oi, "Passwords do not match")) : v("", !0),
                Z.value ? (s(), r("em", ui, "Password must be at least 8 characters")) : v("", !0)
              ], 64)) : v("", !0),
              n("div", di, [
                _(ge, {
                  type: "text",
                  label: "First Name",
                  autocomplete: "given-name",
                  modelValue: l.value.first_name,
                  "onUpdate:modelValue": e[6] || (e[6] = (t) => l.value.first_name = t),
                  required: "",
                  invalid: m.value.shippingData.first_name,
                  floating: !0
                }, null, 8, ["modelValue", "invalid"]),
                _(ge, {
                  type: "text",
                  label: "Last Name",
                  modelValue: l.value.last_name,
                  "onUpdate:modelValue": e[7] || (e[7] = (t) => l.value.last_name = t),
                  required: "",
                  invalid: m.value.shippingData.last_name,
                  floating: !0
                }, null, 8, ["modelValue", "invalid"])
              ]),
              n("div", pi, [
                _(ls, {
                  modelValue: l.value.phone,
                  "onUpdate:modelValue": e[8] || (e[8] = (t) => l.value.phone = t),
                  "field-label": "Mobile Phone",
                  required: ""
                }, null, 8, ["modelValue"]),
                _(os, {
                  ref: "dob",
                  modelValue: l.value.birthday,
                  "onUpdate:modelValue": e[9] || (e[9] = (t) => l.value.birthday = t),
                  "min-age": Ca.value,
                  invalid: m.value.shippingData.birthday,
                  required: ""
                }, null, 8, ["modelValue", "min-age", "invalid"])
              ]),
              o.referralQuestionPlacement === "signup" ? (s(), D(Ot, {
                key: 1,
                source: V.value,
                "onUpdate:source": e[10] || (e[10] = (t) => V.value = t),
                note: J.value,
                "onUpdate:note": e[11] || (e[11] = (t) => J.value = t),
                options: o.referralOptions,
                required: "",
                invalid: m.value.referralSource
              }, null, 8, ["source", "note", "options", "invalid"])) : v("", !0),
              n("label", null, [
                _(It, {
                  modelValue: ke.value,
                  "onUpdate:modelValue": e[12] || (e[12] = (t) => ke.value = t),
                  required: ""
                }, null, 8, ["modelValue"]),
                e[72] || (e[72] = d(" I agree to the ", -1)),
                _(Ee, {
                  href: o.termsUrl
                }, {
                  default: w(() => e[70] || (e[70] = [
                    d("Terms", -1)
                  ])),
                  _: 1,
                  __: [70]
                }, 8, ["href"]),
                e[73] || (e[73] = d(" and ", -1)),
                _(Ee, {
                  href: o.privacyUrl
                }, {
                  default: w(() => e[71] || (e[71] = [
                    d("Privacy Policy", -1)
                  ])),
                  _: 1,
                  __: [71]
                }, 8, ["href"]),
                e[74] || (e[74] = d(" of this website.", -1)),
                e[75] || (e[75] = n("span", { class: "required" }, "*", -1))
              ]),
              a(sa) ? (s(), r("em", {
                key: 2,
                class: "error",
                textContent: u(a(ia).message)
              }, null, 8, vi)) : v("", !0),
              _(Y, {
                class: "offset-checkout-signup",
                disabled: !Ta.value || a(Re),
                onClick: Ie(Aa, ["prevent"]),
                textContent: u(a(Re) ? "Confirming..." : "Confirm")
              }, null, 8, ["disabled", "textContent"])
            ], 64)) : v("", !0),
            L.value ? (s(), D(ns, {
              key: 3,
              email: O.value,
              "redirect-url": ""
            }, null, 8, ["email"])) : v("", !0)
          ], 64))
        ]),
        o.shippingExempt ? v("", !0) : (s(), D(Xe, {
          key: 2,
          label: "Ship To",
          disabled: !a(H),
          locked: Ye.value,
          opened: !a(ca) && !Ye.value
        }, {
          disabled: w(() => e[76] || (e[76] = [])),
          closed: w(() => [
            a(p) ? (s(), r(C, { key: 0 }, [
              d(u(a(p).first_name) + " " + u(a(p).last_name) + ", " + u(a(p).address) + ", " + u(a(p).city) + " " + u(a(p).state) + " " + u(a(p).zip), 1)
            ], 64)) : v("", !0)
          ]),
          opened: w(() => [
            a(vt) ? (s(), D(qe, {
              key: 0,
              label: "Loading Addresses"
            })) : !a(ne) || a(ne).length === 0 || k.value || se.value ? (s(), r(C, { key: 1 }, [
              n("div", fi, [
                e[78] || (e[78] = d(" Please enter an address where someone present and available to sign for your shipment to ensure successful delivery. ", -1)),
                a(x) && a(x).enable_age_restriction ? (s(), r(C, { key: 0 }, [
                  e[77] || (e[77] = n("br", null, null, -1)),
                  d("An adult signature (" + u(a(x).restriction_age) + "+) is required. ", 1)
                ], 64)) : (s(), r(C, { key: 1 }, [
                  d(" An adult signature (21+) is required. ")
                ], 64))
              ]),
              n("div", mi, [
                _(ge, {
                  type: "text",
                  label: "First Name",
                  modelValue: l.value.first_name,
                  "onUpdate:modelValue": e[13] || (e[13] = (t) => l.value.first_name = t),
                  required: "",
                  invalid: m.value.shippingData.first_name,
                  floating: !0
                }, null, 8, ["modelValue", "invalid"]),
                _(ge, {
                  type: "text",
                  label: "Last Name",
                  modelValue: l.value.last_name,
                  "onUpdate:modelValue": e[14] || (e[14] = (t) => l.value.last_name = t),
                  required: "",
                  invalid: m.value.shippingData.last_name,
                  floating: !0
                }, null, 8, ["modelValue", "invalid"])
              ]),
              _(rs, {
                country: l.value.country,
                "onUpdate:country": e[15] || (e[15] = (t) => l.value.country = t),
                address: l.value.address,
                "onUpdate:address": e[16] || (e[16] = (t) => l.value.address = t),
                address2: l.value.address2,
                "onUpdate:address2": e[17] || (e[17] = (t) => l.value.address2 = t),
                city: l.value.city,
                "onUpdate:city": e[18] || (e[18] = (t) => l.value.city = t),
                state: l.value.state,
                "onUpdate:state": e[19] || (e[19] = (t) => l.value.state = t),
                zip: l.value.zip,
                "onUpdate:zip": e[20] || (e[20] = (t) => l.value.zip = t),
                company: l.value.businessName,
                "onUpdate:company": e[21] || (e[21] = (t) => l.value.businessName = t),
                validStates: a(ma),
                validCountries: Ea.value,
                "invalid-address": m.value.shippingData.address,
                "invalid-city": m.value.shippingData.city,
                "invalid-state": m.value.shippingData.state,
                "invalid-zip": m.value.shippingData.zip
              }, {
                international: w(() => e[79] || (e[79] = [
                  n("div", { class: "offset-checkout-info" }, " For our international customers, we will reach out to you to confirm your shipping address. Applicable tax and/or shipping charges are added after your order is processed. ", -1)
                ])),
                _: 1
              }, 8, ["country", "address", "address2", "city", "state", "zip", "company", "validStates", "validCountries", "invalid-address", "invalid-city", "invalid-state", "invalid-zip"]),
              n("div", ci, [
                _(Y, {
                  onClick: qa,
                  disabled: b.value
                }, {
                  default: w(() => e[80] || (e[80] = [
                    d("Save", -1)
                  ])),
                  _: 1,
                  __: [80]
                }, 8, ["disabled"]),
                a(ne) && a(ne).length > 0 ? (s(), D(Y, {
                  key: 0,
                  onClick: Na,
                  variant: "alt",
                  disabled: b.value
                }, {
                  default: w(() => e[81] || (e[81] = [
                    d("Cancel", -1)
                  ])),
                  _: 1,
                  __: [81]
                }, 8, ["disabled"])) : v("", !0)
              ])
            ], 64)) : (s(), r(C, { key: 2 }, [
              a(vt) || a(oa) ? (s(), D(qe, {
                key: 0,
                label: "Loading Addresses"
              })) : (s(!0), r(C, { key: 1 }, Le(a(ne), (t) => (s(), r("label", {
                key: t.id,
                class: ye(["offset-checkout-address", {
                  active: a(p) && t.id == a(p).id
                }])
              }, [
                _(De, {
                  name: "address",
                  value: t.id,
                  checked: a(p) && t.id == a(p).id,
                  onChange: (c) => a(ua)(t.id)
                }, null, 8, ["value", "checked", "onChange"]),
                n("div", null, [
                  n("strong", null, u(t.first_name) + " " + u(t.last_name) + ", " + u(t.address), 1),
                  e[82] || (e[82] = n("br", null, null, -1)),
                  d(" " + u(t.city) + ", " + u(t.state) + " " + u(t.zip), 1)
                ]),
                _(ts, {
                  onClick: e[22] || (e[22] = Ie(() => {
                  }, ["stop"]))
                }, {
                  default: w(() => [
                    _(Y, {
                      onClick: (c) => Va(t.id)
                    }, {
                      default: w(() => e[83] || (e[83] = [
                        d("Edit", -1)
                      ])),
                      _: 2,
                      __: [83]
                    }, 1032, ["onClick"]),
                    _(Y, {
                      onClick: (c) => Fa(t.id)
                    }, {
                      default: w(() => e[84] || (e[84] = [
                        d("Remove", -1)
                      ])),
                      _: 2,
                      __: [84]
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ], 2))), 128)),
              n("div", gi, [
                _(Y, {
                  onClick: za,
                  variant: "alt"
                }, {
                  default: w(() => e[85] || (e[85] = [
                    d(" Use a different address ", -1)
                  ])),
                  _: 1,
                  __: [85]
                })
              ])
            ], 64))
          ]),
          _: 1
        }, 8, ["disabled", "locked", "opened"])),
        o.shippingExempt ? v("", !0) : (s(), D(Xe, {
          key: 3,
          class: ye(["offset-checkout-shipping"]),
          label: "Shipping Method",
          disabled: !a(H),
          locked: Ye.value,
          alwaysOpen: !0
        }, {
          closed: w(() => {
            var t;
            return [
              me.value ? (s(), r(C, { key: 0 }, [
                d(u(me.value.description) + " — " + u(me.value.full_address), 1)
              ], 64)) : (s(), r(C, { key: 1 }, [
                d(u((t = a(Q)) == null ? void 0 : t.name) + " ", 1),
                a(Q) && !a(f)(a(Q).description) ? (s(), r("div", {
                  key: 0,
                  class: "offset-checkout-shipping-option-description",
                  innerHTML: a(Q).description
                }, null, 8, yi)) : v("", !0)
              ], 64))
            ];
          }),
          opened: w(() => [
            !a(H) || a(Be).length === 0 ? (s(), r(C, { key: 0 }, [
              a(na) ? (s(), r("div", hi, [
                _($e)
              ])) : a(ra) ? (s(), r("div", _i, " Something went wrong loading shipping methods. Please refresh the page and try again. ")) : (s(), r("div", ki, " Enter your shipping address to view available shipping methods. "))
            ], 64)) : (s(), r(C, { key: 1 }, [
              _(ss, null, {
                default: w(() => [
                  (s(!0), r(C, null, Le(La.value, (t) => (s(), D(is, {
                    key: t.type,
                    title: t.type,
                    class: "offset-checkout-shipping-option"
                  }, {
                    default: w(() => [
                      (s(!0), r(C, null, Le(t.options, (c, h) => {
                        var ve, fe;
                        return s(), r("label", {
                          key: c.id
                        }, [
                          _(De, {
                            name: "shippingMethod",
                            value: h,
                            checked: c.id == ((ve = ft.value) == null ? void 0 : ve.id),
                            onChange: (_e) => ka(c.id)
                          }, null, 8, ["value", "checked", "onChange"]),
                          d(" " + u(c.name) + " - " + u(a(jt)(c.rate)) + " ", 1),
                          c.id == ((fe = ft.value) == null ? void 0 : fe.id) ? (s(), r(C, { key: 0 }, [
                            e[86] || (e[86] = n("br", null, null, -1)),
                            n("div", {
                              class: "offset-checkout-shipping-option-description",
                              innerHTML: c.description
                            }, null, 8, bi)
                          ], 64)) : v("", !0)
                        ]);
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["title"]))), 128))
                ]),
                _: 1
              }),
              a(x).enable_insurance ? (s(), r("label", wi, [
                n("strong", null, [
                  _(It, {
                    modelValue: !!parseInt(a(E).config.insurance),
                    "onUpdate:modelValue": e[23] || (e[23] = (t) => a(be)({ insurance: t ? 1 : 0 }))
                  }, null, 8, ["modelValue"]),
                  e[87] || (e[87] = d(" Shipping Insurance? ", -1))
                ]),
                n("span", {
                  textContent: u(
                    a(f)(a(x).cart_insurance) ? "1" : a(x).cart_insurance
                  )
                }, null, 8, Si),
                e[88] || (e[88] = d("% of the subtotal covers loss or damage in transit. Does not include weather related damage. ", -1))
              ])) : v("", !0),
              a(p) && a(x).enable_pickup_locations ? (s(), r(C, { key: 1 }, [
                e[89] || (e[89] = n("div", { class: "offset-checkout-pickup-locations-header" }, " Pickup Locations ", -1)),
                _(Ns, {
                  address: a(p).address,
                  city: a(p).city,
                  state: a(p).state,
                  zip: a(p).zip,
                  "order-price": a(E).total,
                  selectedLocationId: He.value,
                  "onUpdate:selectedLocationId": e[24] || (e[24] = (t) => He.value = t),
                  onSelect: ba
                }, null, 8, ["address", "city", "state", "zip", "order-price", "selectedLocationId"])
              ], 64)) : v("", !0)
            ], 64))
          ]),
          _: 1
        }, 8, ["disabled", "locked"])),
        !o.shippingExempt && a(Ae).length > 0 ? (s(), r("div", {
          key: 4,
          class: ye([
            "section",
            "offset-checkout-shipping-date",
            a(H) ? "" : "disabled"
          ])
        }, [
          e[93] || (e[93] = n("h3", null, "Please select a requested ship date", -1)),
          (s(!0), r(C, null, Le(a(Ae), (t) => (s(), r("label", { key: t }, [
            _(De, {
              name: "requestedShipDate",
              value: t,
              checked: t == a(pe) && !B.value,
              onChange: (c) => {
                B.value = !1, a(be)({ requested_ship_date: t });
              }
            }, null, 8, ["value", "checked", "onChange"]),
            d(" " + u(a(Lt)(t)), 1)
          ]))), 128)),
          n("label", null, [
            _(De, {
              name: "requestedShipDate",
              value: "arrange",
              checked: B.value,
              onChange: e[25] || (e[25] = (t) => {
                B.value = !0, a(be)({ requested_ship_date: "" });
              })
            }, null, 8, ["checked"]),
            e[92] || (e[92] = d(" Please arrange a different date ", -1)),
            B.value ? (s(), r(C, { key: 0 }, [
              e[90] || (e[90] = n("br", null, null, -1)),
              e[91] || (e[91] = n("div", { class: "offset-checkout-shipping-option-description" }, " We will reach out to you to schedule your shipment. ", -1))
            ], 64)) : v("", !0)
          ])
        ], 2)) : v("", !0),
        _(as, {
          class: "section",
          disabled: !a(H),
          shippingExempt: o.shippingExempt,
          first_name: T.value.first_name,
          "onUpdate:first_name": e[26] || (e[26] = (t) => T.value.first_name = t),
          last_name: T.value.last_name,
          "onUpdate:last_name": e[27] || (e[27] = (t) => T.value.last_name = t),
          address: T.value.address,
          "onUpdate:address": e[28] || (e[28] = (t) => T.value.address = t),
          address_2: T.value.address_2,
          "onUpdate:address_2": e[29] || (e[29] = (t) => T.value.address_2 = t),
          city: T.value.city,
          "onUpdate:city": e[30] || (e[30] = (t) => T.value.city = t),
          state: T.value.state,
          "onUpdate:state": e[31] || (e[31] = (t) => T.value.state = t),
          zip: T.value.zip,
          "onUpdate:zip": e[32] || (e[32] = (t) => T.value.zip = t),
          country: T.value.country,
          "onUpdate:country": e[33] || (e[33] = (t) => T.value.country = t),
          company: T.value.businessName,
          "onUpdate:company": e[34] || (e[34] = (t) => T.value.businessName = t),
          editingPayment: ze.value,
          "onUpdate:editingPayment": e[35] || (e[35] = (t) => ze.value = t),
          addingPayment: Ve.value,
          "onUpdate:addingPayment": e[36] || (e[36] = (t) => Ve.value = t),
          onPaymentTypeChanged: e[37] || (e[37] = (t) => te.value = t)
        }, null, 8, ["disabled", "shippingExempt", "first_name", "last_name", "address", "address_2", "city", "state", "zip", "country", "company", "editingPayment", "addingPayment"]),
        a(f)(a(x).message_checkout_payment) ? v("", !0) : (s(), r("p", {
          key: 5,
          class: "offset-checkout-info",
          innerHTML: a(x).message_checkout_payment
        }, null, 8, Ci)),
        _(Xe, {
          label: "Special Instructions",
          disabled: !a(H)
        }, {
          closed: w(() => [
            ie.value || le.value ? (s(), r("div", Ui, [
              ie.value ? (s(), r("p", Pi, [
                e[94] || (e[94] = d("Order Notes:", -1)),
                e[95] || (e[95] = n("br", null, null, -1)),
                d(u(ie.value), 1)
              ])) : v("", !0),
              le.value ? (s(), r("p", xi, [
                e[96] || (e[96] = d("Gift Message:", -1)),
                e[97] || (e[97] = n("br", null, null, -1)),
                d(u(le.value), 1)
              ])) : v("", !0)
            ])) : v("", !0)
          ]),
          opened: w(() => [
            n("div", Ei, [
              n("label", null, [
                _(Tt, {
                  modelValue: ie.value,
                  "onUpdate:modelValue": e[38] || (e[38] = (t) => ie.value = t),
                  maxlength: 200,
                  label: "Order Notes",
                  floating: !0
                }, null, 8, ["modelValue"]),
                n("small", Li, u((ie.value || "").length) + "/200", 1)
              ]),
              n("label", null, [
                _(Tt, {
                  modelValue: le.value,
                  "onUpdate:modelValue": e[39] || (e[39] = (t) => le.value = t),
                  maxlength: 200,
                  label: "Gift Message",
                  floating: !0
                }, null, 8, ["modelValue"]),
                n("small", Ii, u((le.value || "").length) + "/200", 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"])
      ])),
      _(es, {
        class: ye(["offset-checkout-cart", Fe.value ? "is-cart-shown" : ""]),
        cartUrl: o.cartUrl,
        checkoutUrl: o.checkoutUrl,
        shopUrl: o.shopUrl,
        readOnly: P.value || a(ue),
        isOffering: o.isOffering,
        shippingExempt: o.shippingExempt,
        overrideCart: P.value ? rt.value : null
      }, {
        header: w(() => [
          P.value ? (s(), r("div", Oi)) : (s(), r("div", Di, [
            _(Y, {
              class: "offset-checkout-hide-cart",
              variant: "alt",
              "aria-label": "Close cart",
              onClick: Ia
            }, {
              default: w(() => e[98] || (e[98] = [
                d("x", -1)
              ])),
              _: 1,
              __: [98]
            })
          ]))
        ]),
        editcart: w(() => [
          !P.value && !a(ue) ? (s(), r("div", Ti, [
            Ce.value ? v("", !0) : (s(), D(Ee, {
              key: 0,
              href: o.isOffering ? o.offeringUrl : o.shopUrl
            }, {
              default: w(() => e[99] || (e[99] = [
                d("Edit Items", -1)
              ])),
              _: 1,
              __: [99]
            }, 8, ["href"]))
          ])) : v("", !0)
        ]),
        actions: w(() => [
          n("div", Ai, [
            ce.value ? (s(), r("div", zi, u(ce.value), 1)) : v("", !0),
            P.value ? (s(), D(Y, {
              key: 2,
              class: "offset-checkout-pay-now",
              variant: "alt",
              onClick: e[40] || (e[40] = (t) => yt(o.shopUrl))
            }, {
              default: w(() => e[100] || (e[100] = [
                d(" Keep Shopping ", -1)
              ])),
              _: 1,
              __: [100]
            })) : (s(), D(Y, {
              key: 1,
              class: "offset-checkout-pay-now",
              onClick: Wa,
              disabled: !je.value || a(ut) || Ue.value || a(va)
            }, {
              default: w(() => [
                d(u(Ua.value), 1)
              ]),
              _: 1
            }, 8, ["disabled"])),
            je.value && !P.value ? (s(), r("div", Vi, [
              d(" By placing your order, you authorize " + u(a(x).company_name) + " to charge your credit, and you agree to the ", 1),
              n("a", {
                href: o.termsUrl
              }, "Terms & Conditions", 8, Fi),
              e[101] || (e[101] = d(" and ", -1)),
              n("a", {
                href: o.privacyUrl
              }, "Privacy Policy", 8, Ni),
              e[102] || (e[102] = d(". ", -1))
            ])) : v("", !0),
            P.value ? v("", !0) : (s(), D(ys, { key: 4 }))
          ])
        ]),
        "below-summary": w(() => [
          !P.value && !Ce.value ? (s(), r("div", Mi, [
            e[103] || (e[103] = d(" Powered by ", -1)),
            n("a", {
              href: Pa.value,
              target: "_blank",
              rel: "noopener"
            }, "Offset Commerce", 8, $i)
          ])) : v("", !0)
        ]),
        _: 1
      }, 8, ["class", "cartUrl", "checkoutUrl", "shopUrl", "readOnly", "isOffering", "shippingExempt", "overrideCart"])
    ], 2));
  }
}, Cl = /* @__PURE__ */ it(qi, [["__scopeId", "data-v-f76cfe57"]]);
export {
  Cl as C
};
